<mat-card>
    <mat-card-title class="mc-title">
        <div class="text-center">
            <img src="/assets/images/logo-sim.png" alt="logo-sim">
        </div>
    </mat-card-title>
    <mat-card-content>
        <form [formGroup]="recuperarClaveForm">
            <div class="form-group">
                <label for="exampleInputEmail1">{{ 'recuperarClave.newPassword' | translate }}:</label>
                <input type="password" class="form-control" formControlName="newPassword" placeholder="{{ 'recuperarClave.digitarPassword' | translate }}">
                <span class="form-text text-muted" *ngIf="recuperarClaveForm.controls.newPassword.errors && recuperarClaveForm.controls.newPassword.touched" style="color: #dc3545 !important;">
                    {{ 'recuperarClave.newPasswordError' | translate }}
                </span>
            </div>
            <div class="form-group" style="margin-bottom: 5px;">
                <label for="exampleInputPassword1">{{ 'recuperarClave.validarNewPassword' | translate }}:</label>
                <input type="password" class="form-control" formControlName="validPassword" placeholder="{{ 'recuperarClave.digitarValidacion' | translate }}">
                <span class="form-text text-muted" *ngIf="recuperarClaveForm.controls.validPassword.errors && recuperarClaveForm.controls.validPassword.touched" style="color: #dc3545 !important;">
                    {{ 'recuperarClave.validarNewPasswordError' | translate }}
                </span>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions class="card-action">
        <button class="btn-middle btn-login" mat-dialog-close> {{ "recuperarClave._cancelar" | translate  }}</button>
        <button mat-button class="btn-login" (click)="onSubmit(recuperarClaveForm.value)">{{ "recuperarClave._registrar" | translate  }}</button>
        <div *ngIf="_isLoadingResults" class="d-flex justify-content-center row mt-3">
            <mat-spinner [diameter]="30"></mat-spinner>
            <span class="ml-2" style="font-size: 16px; margin-top: 7px;">{{ 'Main._cargando' | translate }}</span>
        </div>
    </mat-card-actions>
</mat-card>